export default __webpack_public_path__ + "static/media/header-d-old.5f92feeb.png";